// TODO: Remove this file post NOVO conversion
import { setupArtistSignUpModal } from "desktop/components/artistSignupModal/artistSignupModal"

export const artistClient = () => {
  setupArtistSignUpModal()
}
